import React from 'react';
import { Form, Input, Row, Col, Button, Upload, Select, Switch } from 'antd';
import { FolderOpenOutlined } from '@ant-design/icons';
import cover from '../../../../assets/icons/image/01.svg';
import Loading from '../../../../shared/components/Loading/Index';

const { Option } = Select;

export default function FormContent(props) {
    return (
        <Loading visible={props.loading} label="cargando">
            <Form
                form={props.form}
                layout="vertical"
                initialValues={{
                    visible: true,
                    productIds: []
                }}
            >
                <Form.Item name="index" style={{ display: 'none' }}>
                    <Input type="number" />
                </Form.Item>

                <Row gutter={15}>
                    <Col span={24} className='mt-20 mb-30'>
                        <div className='catalog-card-content'>
                            <div className='catalog-card-item'>
                                <div className="vertical-center h-100">
                                    <img src={props.file === undefined ? cover : props.file.stringBase64 ?? props.file.url} alt="card" />
                                </div>
                            </div>
                            <div className='catalog-card-info'>
                                <div className="flex-parent">
                                    <div className="flex-child long-and-truncated">
                                        <div className='ml-5' style={{ whiteSpace: 'normal' }}>
                                            *.png *.jpg *.jpeg *.gif *.tiff *.svg *.webp
                                        </div>
                                    </div>
                                    <div className="flex-child short-and-fixed">
                                        <div className='mt-5'>
                                            <Upload
                                                multiple={false}
                                                showUploadList={false}
                                                beforeUpload={props.onBefore}
                                            >
                                                <Button
                                                    type="text"
                                                    shape='round'
                                                    icon={<FolderOpenOutlined />}
                                                >
                                                    Subir Imagen
                                                </Button>
                                            </Upload>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Título"
                            name="title"
                            className='input-material'
                        >
                            <Input
                                size='large'
                                placeholder='Ingresar título'
                                autoComplete='off'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Subtítulo"
                            name="subTitle"
                            className='input-material'
                        >
                            <Input
                                size='large'
                                placeholder="Ingresar subtítulo"
                                autoComplete="off"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Productos"
                            name="productIds"
                            className='input-material mb-15'
                        >
                            <Select
                                size='large'
                                mode="multiple"
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                placeholder="Agregar productos . . ."
                            >
                                {props.products?.map(item => (
                                    <Option
                                        key={item.id}
                                        value={item.id}
                                        label={item.name}
                                    >
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Visible"
                            name="visible"
                            valuePropName="checked"
                        >
                            <Switch defaultChecked checkedChildren="SÍ" unCheckedChildren="NO" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Loading>
    );
}